const navigateToApp = (path: string) => {
    globalThis.location.replace(path)
}

export const navigateToDriverAppCity = () => {
    navigateToApp('drivee://open/driver/appcity')
}

export const navigateToClientAppCity = () => {
    navigateToApp('drivee://open/client/appcity')
}

export const navigateToTaxoparkCabinet = () => {
    navigateToApp(`drivee://web?cred=true&url=https://indels.app/webview/cabinet`)
}
